import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useAppSelector } from '../../reducers';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { TitleContainer } from '../plan-builder/SharedComponents';
import { InterstitialTileTitle } from './SharedComponents';
export const InterstitialSeatsTile = ({
  productLine,
  price,
  title,
  description,
  children
}) => {
  const currencyCode = useAppSelector(activeCurrencySelector);
  const imageSrc = ProductLinePageIcons[productLine];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(TitleContainer, {
          direction: "row",
          justify: "between",
          align: "end",
          className: "m-bottom-3",
          children: /*#__PURE__*/_jsxs("div", {
            className: "align-center",
            children: [/*#__PURE__*/_jsx(UIImage, {
              className: "display-inline m-bottom-1 m-right-2",
              src: imageSrc,
              width: 24
            }), /*#__PURE__*/_jsx(InterstitialTileTitle, {
              style: {
                marginBottom: 0
              },
              children: title
            })]
          })
        }), description && /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: '55ch'
          },
          children: description
        }), /*#__PURE__*/_jsx("div", {
          className: "m-bottom-4",
          children: /*#__PURE__*/_jsx(UIFlex, {
            direction: "column",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: 'planBuilder.priceDisplay.perMonthPerSeat',
              options: {
                price: /*#__PURE__*/_jsx(PriceDisplay, {
                  price: price,
                  currencyCode: currencyCode
                })
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(UIFlex, {
        direction: "column",
        style: {
          maxWidth: '100px'
        },
        children: children
      })]
    })
  });
};